import React, { useEffect, useState } from "react";

const ProductQuantityInput = ({ value, onCommit }) => {
  const [localValue, setLocalValue] = useState(String(value ?? 0));
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!isEditing) {
      setLocalValue(String(value ?? 0));
    }
  }, [value, isEditing]);

  const commitValue = () => {
    const parsed = localValue.trim() === "" ? 0 : Number(localValue);
    onCommit(Number.isFinite(parsed) ? parsed : 0);
    setIsEditing(false);
  };

  return (
    <input
      type="text"
      inputMode="numeric"
      className="num number product-qty-input"
      value={isEditing ? localValue : String(value ?? 0)}
      onFocus={(event) => {
        setIsEditing(true);
        setLocalValue(String(value ?? 0));
        event.target.select();
      }}
      onChange={(event) => {
        const next = event.target.value.replace(/\D/g, "");
        setLocalValue(next);

        if (next === "") {
          return;
        }

        const parsed = Number(next);
        if (Number.isFinite(parsed)) {
          onCommit(parsed);
        }
      }}
      onBlur={commitValue}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.target.blur();
        }
      }}
    />
  );
};

export default ProductQuantityInput;
